import { Component } from 'react'
import * as styles from 'components/features/socialFeed/SocialProfileForm/SocialProfileForm.styl'
import { reduxForm } from 'redux-form'
import { getSaveButtonFormProps } from 'helpers/formHelpers'
import { FORM_SOCIAL_PROFILE } from 'constants/forms'
import { ReduxFormProps } from 'interfaces/component'
import schema from 'schemas/socialProfileFormSchema'
import { asyncValidator } from 'helpers/schemaHelpers'
import Button from 'components/features/pfm/Button/Button'
import SocialProfileInfoContainer from 'components/features/socialFeed/SocialProfileInfo/SocialProfileInfoContainer'
import { SocialProfileFormValues } from 'interfaces/feed'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'

export type SocialProfileStateProps = Pick<ReduxFormProps<SocialProfileFormValues>, 'initialValues' | 'onSubmit'>
export type SocialProfileFormOwnProps = ReduxFormProps<SocialProfileFormValues>

export type SocialProfileFormProps =
  & SocialProfileStateProps
  & SocialProfileFormOwnProps

const customShouldAsyncValidate = ({ trigger }: { trigger: string }) =>
  trigger === 'submit' || trigger === 'blur' || trigger === 'change'

@reduxForm({
  form: FORM_SOCIAL_PROFILE,
  touchOnChange: true,
  asyncValidate: asyncValidator(schema),
  shouldAsyncValidate: customShouldAsyncValidate,
})
class SocialProfileForm extends Component<SocialProfileFormProps> {
  render () {
    const { handleSubmit } = this.props

    return (
      <form className={ styles.socialProfileForm } onSubmit={ handleSubmit }>
        <SocialProfileInfoContainer readonly={ false } />
        <AnalyticsClick
          className={ styles.submitButtonWrapper }
          category='module-feed_profile'
          action='click-save_nickname'
        >
          <Button
            submit
            fullWidth
            qaMarker='submit-button'
            { ...getSaveButtonFormProps(this.props) }
          >
            Save Nickname
          </Button>
        </AnalyticsClick>
      </form>
    )
  }
}

export default SocialProfileForm
